import React, { Context, useContext, useRef } from "react";
import {
  Link
} from "react-router-dom";
import { ReactComponent as HomeIcon } from "../../assets/icons/home-private.svg";
import classes from "./Hit.module.scss";
import { SanitizeHTML } from "../SanitizeHtml/SanitizeHtml";

import { ReactComponent as ArrowRightIcon } from "../../assets/icons/arrow-right.svg";
import timeUnits from "../../constants/timeUnits";
import { getContextFromWidget } from "../../helpers/context";

interface HitProps {
  hit: {
    title: string;
    objectID: string;
    region: string;
    lastUpdated: string;
    studyArea: string;
    updatedDate: number;
    remote: boolean;
  };
  [x: string]: any;
}

export const Hit = ({ hit, sendEvent }: HitProps) => {
  const { postedDatesSchema } = useContext(
    getContextFromWidget(process.env.REACT_APP_WIDGET_MODE) as Context<any>
  );
  const titleRef = useRef<HTMLDivElement>(null);
  const convertTimeAgo = (current: number, previous: number) => {
    const elapsed = current - previous;

    if (elapsed < timeUnits.day) {
      return postedDatesSchema?.today;
    } else if (elapsed > timeUnits.day && elapsed < timeUnits.day * 2) {
      return postedDatesSchema?.yesterday;
    } else if (elapsed < timeUnits.week) {
      return postedDatesSchema?.daysAgo.replace(
        "{n}",
        `${Math.round(elapsed / timeUnits.day)}`
      );
    } else if (elapsed > timeUnits.week && elapsed < timeUnits.week * 2) {
      return postedDatesSchema?.lastWeek;
    } else if (elapsed < timeUnits.month) {
      return postedDatesSchema?.weeksAgo.replace(
        "{n}",
        `${Math.round(elapsed / timeUnits.week)}`
      );
    } else if (elapsed > timeUnits.month && elapsed < timeUnits.month * 2) {
      return postedDatesSchema?.lastMonth;
    } else if (elapsed < timeUnits.year) {
      return postedDatesSchema?.monthsAgo.replace(
        "{n}",
        `${Math.round(elapsed / timeUnits.month)}`
      );
    } else {
      return postedDatesSchema?.yearAgo;
    }
  };
  return (
    <Link
      to={() => ({
        pathname: window.location.pathname,
        search: `?jobId=${hit.objectID}`,
        state: window.location.search,
      })}
      className={classes.hit}
    >
      <div className={classes.hitTitleWrapper}>
        <h3 ref={titleRef} className={classes.hitTitle}>
          <SanitizeHTML html={hit?.title ? hit.title : ""} />
        </h3>
        <ArrowRightIcon />
      </div>

      {hit?.studyArea && (
        <div className={classes.hitSubTitle}>
          {hit?.studyArea && typeof hit?.studyArea === "string"
            ? hit.studyArea
            : ""}
          {hit?.studyArea && typeof hit?.studyArea !== "string"
            ? hit.studyArea[0]
            : ""}
        </div>
      )}
      {hit?.region && (
        <div className={classes.hitRegionBox}>
          {hit?.remote && (
            <span className={classes.remoteIcon}>
              <HomeIcon />
            </span>
          )}
          {hit.region}
        </div>
      )}
      {hit?.lastUpdated && (
        <div className={classes.hitLastUpdated}>
          {convertTimeAgo(Date.now(), hit.updatedDate)}
        </div>
      )}
    </Link>
  );
};
